import { Box, Center, Heading, Spacer, Text, VStack } from '@chakra-ui/react'
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext'
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel'
import { UserGoalsForm } from '@src/components/sco/Account/UserGoalsForm'
import { UserSprintSelector } from '@src/components/sco/Account/UserSprintSelector'
import { FormContainer } from '@src/components/sco/FormContainer'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { AccountPage } from '@src/layouts/AccountPageLayout'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default AccountPage(function () {
  const accountContext = useAccountContext()
  const activeContent = useActiveContentContext()
  const { getBreakpointValue } = useBreakpointContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('account.goals')
  })

  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([
      {
        title: 'Account',
        href: '/account',
      },

      {
        title: 'Goals',
        href: '/account/goals',
      },
    ])
  }, [])

  return (
    <AccountMainPanel>
      <Center minHeight={'80vh'}>
        <Box maxWidth={'960px'} padding={'1em'} width={'full'}>
          <UserGoalsForm />
          <Spacer height={8} />
          <FormContainer>
            <VStack align={'stretch'} gap={'1.5em'} width={'full'}>
              <VStack align={'stretch'} gap={'0.5em'}>
                <Heading>What is your top goal or challenge right now?</Heading>
                <Text fontSize={'md'} opacity={0.7}>
                  Pick ONE of our Startup Sprints so we can help you focus on achieving your goal. You can
                  change this after you crush this first goal, or if your goals change dramatically.
                </Text>
              </VStack>
              <UserSprintSelector hideHeader={true} />
            </VStack>
          </FormContainer>
        </Box>
      </Center>
    </AccountMainPanel>
  )
})
